import color from './color'
import typography from './typography'
import spacing from './spacing'
import animation from './animation'
import measures from './measures'
import { ThemeType } from './types'
import zIndex from './zIndex'
import utils from './utils'
import { colorConfig } from '@themes/config'

const defaultTheme = {
  color,
  typography,
  spacing,
  animation,
  measures,
  zIndex,
  utils,
  colors: colorConfig,
} as const satisfies ThemeType<typeof colorConfig>

export default defaultTheme
